import { render, staticRenderFns } from "./ordersum.vue?vue&type=template&id=123a5e42&scoped=true&"
import script from "./ordersum.vue?vue&type=script&lang=js&"
export * from "./ordersum.vue?vue&type=script&lang=js&"
import style1 from "./ordersum.vue?vue&type=style&index=1&id=123a5e42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123a5e42",
  null
  
)

export default component.exports